// utils/formatTimeOnly.ts
export const formatTimeOnly = (dateString: string | undefined): string => {
    if (!dateString) return '--'; // Return '--' if the date string is empty or undefined
  
    const date = new Date(dateString); // Convert string to Date object
  
    // Check if it's a valid date
    if (isNaN(date.getTime())) return '--'; // If not a valid date, return '--'
  
    // Format the time to "HH:mm" format (hours and minutes)
    return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  };
  